import useTranslator from "../../hooks/useTranslator";
import ProfileImg from "../../assets/img/profileImg.svg";
import noticIcon from "../../assets/img/noticIcon.svg";
import { haveValue } from "../../helper/common";
import CheckIcon0 from "../../assets/img/checkIcon02.svg";
import { useState } from "react";

const DetailsPersonalInfo = (props) => {
  const { user = null, forensicAnalysis = {}, handleInfoModal } = props;
  const { _t } = useTranslator();
  const llShowOnly = localStorage.getItem("usertype") == "landlord";

  return (
    <>
      <div className="main_doc_div">
        <div className="d-flex align-items-center gap-2 BorderB2">
          <img src={ProfileImg} alt="Vector Icon" className="vactorImg2" />
          <p className="docheader">{_t("personalInformation")}</p>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div
              className={`Indo_form BorderB2 ${
                haveValue(forensicAnalysis?.Name) && llShowOnly
                  ? "custom-tooltip cursor-pointer"
                  : ""
              }`}
              data-tooltip={_t("clickHereToSeeDetails")}
              onClick={(e) => {
                if (haveValue(forensicAnalysis?.Name) && llShowOnly) {
                  handleInfoModal(forensicAnalysis?.Name);
                }
              }}
            >
              <div className="d-flex align-items-center gap-1">
                <p className="formlabel d-block">{_t("name")}</p>
                <div className=" d-flex align-items-center gap-1">
                  {forensicAnalysis?.Name?.verifiedSource === true ? (
                    <img
                      src={CheckIcon0}
                      alt="Vector Icon"
                      className="validationIcon"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <p className="placeholderTest">
                {haveValue(forensicAnalysis?.Name?.dataInJSON?.name)
                  ? forensicAnalysis?.Name?.dataInJSON?.name
                  : `${user?.fname ?? ""} ${user?.lname ?? ""}`}
              </p>
            </div>
          </div>

          {(haveValue(forensicAnalysis?.DNI?.dataInJSON?.dni) ||
            haveValue(user?.dni_nie)) && (
            <div className="col-md-4 col-6">
              <div
                className={`Indo_form BorderB2 ${
                  haveValue(forensicAnalysis?.DNI?.dataInJSON?.dni) &&
                  llShowOnly
                    ? "custom-tooltip cursor-pointer"
                    : ""
                }`}
                data-tooltip={_t("clickHereToSeeDetails")}
                onClick={() => {
                  if (
                    haveValue(forensicAnalysis?.DNI?.dataInJSON?.dni) &&
                    llShowOnly
                  ) {
                    handleInfoModal(forensicAnalysis?.DNI);
                  }
                }}
              >
                <div className="d-flex align-items-center gap-1">
                  <p className="formlabel d-block">{_t("dniNie")}</p>
                  {forensicAnalysis?.DNI?.verifiedSource === true && (
                    <div className="d-flex align-items-center gap-1">
                      <img
                        src={CheckIcon0}
                        alt="Vector Icon"
                        className="validationIcon"
                      />
                    </div>
                  )}
                </div>

                <p className="placeholderTest">
                  {haveValue(forensicAnalysis?.DNI?.dataInJSON?.dni)
                    ? forensicAnalysis?.DNI?.dataInJSON?.dni
                    : haveValue(user?.dni_nie)
                    ? user?.dni_nie
                    : ""}
                </p>
              </div>
            </div>
          )}

          {(haveValue(forensicAnalysis?.Passport?.dataInJSON?.passportNumber) ||
            haveValue(user?.passport_id)) && (
            <div className="col-md-4 col-6">
              <div
                className={`Indo_form BorderB2 ${
                  haveValue(
                    forensicAnalysis?.Passport?.dataInJSON?.passportNumber
                  ) && llShowOnly
                    ? "custom-tooltip cursor-pointer"
                    : ""
                }`}
                data-tooltip={_t("clickHereToSeeDetails")}
                onClick={() => {
                  if (
                    haveValue(
                      forensicAnalysis?.Passport?.dataInJSON?.passportNumber
                    ) &&
                    llShowOnly
                  ) {
                    handleInfoModal(forensicAnalysis?.Passport);
                  }
                }}
              >
                <div className="d-flex align-items-center gap-1">
                  <p className="formlabel d-block">{_t("passport")}</p>
                  {forensicAnalysis?.Passport?.verifiedSource === true && (
                    <div className="d-flex align-items-center gap-1">
                      <img
                        src={CheckIcon0}
                        alt="Vector Icon"
                        className="validationIcon"
                      />
                    </div>
                  )}
                </div>

                <p className="placeholderTest">
                  {haveValue(
                    forensicAnalysis?.Passport?.dataInJSON?.passportNumber
                  )
                    ? forensicAnalysis?.Passport?.dataInJSON?.passportNumber
                    : haveValue(user?.passport_id)
                    ? user?.passport_id
                    : ""}
                </p>
              </div>
            </div>
          )}

          <div className="col-md-4 col-6">
            <div
              className={`Indo_form BorderB2 ${
                haveValue(forensicAnalysis?.Nationality) && llShowOnly
                  ? "cursor-pointer custom-tooltip"
                  : ""
              }`}
              data-tooltip={_t("clickHereToSeeDetails")}
              onClick={(e) => {
                if (haveValue(forensicAnalysis?.Nationality) && llShowOnly) {
                  handleInfoModal(forensicAnalysis?.Nationality);
                }
              }}
            >
              <div className="d-flex align-items-center gap-1">
                <p className="formlabel d-block">{_t("nationality")}</p>
                <div className=" d-flex align-items-center gap-1">
                  {forensicAnalysis?.Nationality?.verifiedSource === true ? (
                    <img
                      src={CheckIcon0}
                      alt="Vector Icon"
                      className="validationIcon"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <p className="placeholderTest">
                {haveValue(
                  forensicAnalysis?.Nationality?.dataInJSON?.nationality
                )
                  ? _t(
                      forensicAnalysis?.Nationality?.dataInJSON?.nationality,
                      "",
                      "fixed"
                    )
                  : haveValue(user?.nationality)
                  ? _t(user?.nationality, "", "fixed")
                  : "N/A"}
              </p>
            </div>
          </div>
          <div className="col-md-4 col-6">
            <div className="Indo_form BorderB2">
              <div className="d-flex align-items-center gap-1">
                <p className="formlabel d-block">{_t("phoneNumber")}</p>
                <div className=" d-flex align-items-center gap-1">
                  {user?.phone_number_verified && (
                    <img
                      src={CheckIcon0}
                      alt="Vector Icon"
                      className="validationIcon"
                    />
                  )}
                </div>
              </div>
              <p className="placeholderTest">
                {user?.phone_number ? `+${user?.phone_number}` : "N/A"}
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="Indo_form BorderB2">
              <div className="d-flex align-items-center gap-1">
                <p className="formlabel d-block">{_t("email")}</p>
                <div className=" d-flex align-items-center gap-1">
                  <img
                    src={CheckIcon0}
                    alt="Vector Icon"
                    className="validationIcon"
                  />
                </div>
              </div>
              <p className="placeholderTest userEmailText">{user?.email}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailsPersonalInfo;
